import React from "react";
import Link from "gatsby-link";
import Img from "gatsby-image";


export default class Thumbnail extends React.Component {
  render() {
    const {post} = this.props;

    return (
      <div>
        <Link to={`/${post.path}`}>
          <div className="video-thumbnail">
            <div className="video-thumbnail-text">
              <p>
                Watch
              </p>
            </div>
            {
              post.localThumbnail ?
                (
                  <Img
                    className="video-thumbnail-image"
                    position="absolute"
                    style={{position: "absolute"}}
                    sizes={post.localThumbnail.childImageSharp.sizes}
                  />
                ) : (
                  <div className="thumbnail-placeholder">
                    <h5>
                      No Preview Available
                    </h5>
                  </div>
                )
            }
          </div>
        </Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PostListing/Thumbnail.jsx